var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInboundCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.327 11A22.614 22.614 0 00-.28 17.227a1.33 1.33 0 00-.387.946c0 .374.147.707.387.947l3.305 3.307c.24.24.573.386.946.386.36 0 .693-.146.933-.373a15.218 15.218 0 013.546-2.467c.44-.213.746-.666.746-1.2V14.64a19.483 19.483 0 016.13-.973c2.133 0 4.199.333 6.131.96v4.133c0 .52.307.987.747 1.2a15.71 15.71 0 013.558 2.467c.24.24.573.373.933.373.373 0 .707-.147.947-.387l3.305-3.306c.24-.24.386-.574.386-.947s-.16-.693-.4-.933A22.614 22.614 0 0015.327 11z",
    id: "inbound_call_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "inbound_call_svg__b",
    d: "M31.333 3.045l-1.378-1.378-11.333 11.332V6.556h-1.955v9.777h9.777v-1.955h-6.443z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5 -1)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-130 15.333 16.907)",
    xlinkHref: "#inbound_call_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#inbound_call_svg__b"
  }))));
}
export default SvgInboundCall;